import React, { useState } from 'react';
import api from '../api';

export default function Login({ onLogin }) {
  const [isRegister, setIsRegister] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', name: '', role: 'analista' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      let result;
      if (isRegister) {
        result = await api.register(form);
      } else {
        result = await api.login({ email: form.email, password: form.password });
      }
      onLogin(result.user, result.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTestLogin = async () => {
    setLoading(true);
    try {
      const result = await api.testLogin();
      onLogin(result.user, result.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-form-side">
        <div className="login-form-container">
          <h1>LubriStock</h1>
          <p>{isRegister ? 'Crear una nueva cuenta' : 'Inicia sesión en tu cuenta'}</p>
          
          {error && (
            <div style={{ background: 'hsl(0 72% 48% / 0.08)', color: 'hsl(0 72% 40%)', padding: '10px 14px', borderRadius: '8px', fontSize: '0.82rem', marginBottom: '16px' }}>
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            {isRegister && (
              <div className="form-group">
                <label>Nombre</label>
                <input className="form-input" data-testid="register-name-input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Tu nombre completo" />
              </div>
            )}
            <div className="form-group">
              <label>Email</label>
              <input className="form-input" type="email" data-testid="login-email-input" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="correo@empresa.com" required />
            </div>
            <div className="form-group">
              <label>Contraseña</label>
              <input className="form-input" type="password" data-testid="login-password-input" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="••••••••" required />
            </div>
            {isRegister && (
              <div className="form-group">
                <label>Rol</label>
                <select className="filter-select" style={{width:'100%'}} value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
                  <option value="admin">Administrador</option>
                  <option value="gerencia">Gerencia</option>
                  <option value="compras">Compras</option>
                  <option value="almacen">Almacén</option>
                  <option value="analista">Analista</option>
                </select>
              </div>
            )}
            <button className="btn btn-primary" data-testid="login-submit-button" type="submit" disabled={loading} style={{width:'100%', height:'42px', marginTop:'4px'}}>
              {loading ? 'Procesando...' : (isRegister ? 'Crear cuenta' : 'Iniciar sesión')}
            </button>
          </form>
          
          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <button onClick={() => { setIsRegister(!isRegister); setError(''); }} data-testid="register-link" style={{ background: 'none', border: 'none', color: 'hsl(199, 84%, 38%)', cursor: 'pointer', fontSize: '0.82rem' }}>
              {isRegister ? 'Ya tengo cuenta' : 'Crear una cuenta nueva'}
            </button>
          </div>
          
          <div style={{ borderTop: '1px solid hsl(214, 18%, 88%)', marginTop: '20px', paddingTop: '16px', textAlign: 'center' }}>
            <button onClick={handleTestLogin} className="btn btn-secondary" style={{ fontSize: '0.78rem' }} disabled={loading}>
              Acceso rápido (Demo)
            </button>
          </div>
        </div>
      </div>
      <div className="login-image-side">
        <img src="https://images.pexels.com/photos/4483772/pexels-photo-4483772.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" />
        <div className="login-image-overlay">
          <h2>Inventarios Inteligentes para Lubricantes</h2>
          <p>Optimiza tus compras, evita quiebres de stock y toma decisiones basadas en datos.</p>
        </div>
      </div>
    </div>
  );
}
